import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import { setFetchingCart } from "@/redux/slice/cart/slice";
import { GET_GUEST_CART_DETAILS } from "@/components/graphql/serverCartV2";
import { BuildClientPayload } from "@/components/common/types/BuildClientPayload";
import { handleFetchGuestCartResponse } from "@/redux/slice/cart/utils/handleFetchGuestCartResponse";
// import { PharmaAddressDetails } from "@/redux/slice/location/interfaces/PharmaAddressDetails";
import {
  GetGuestCartDetails,
  GetGuestCartDetailsVariables,
} from "@/components/graphql/types/FetchGuestCart";

type FetchGuestCartInput = BuildClientPayload & {
  cartId: string;
  coordinates?: {
    latitude: number;
    longitude: number;
  };
};

export const fetchGuestCart = async (
  fetchGuestCartInput: FetchGuestCartInput,
  dispatch: any,
  pathname: string
) => {
  const { cartId, apolloClient } = fetchGuestCartInput;

  if (cartId) {
    dispatch(setFetchingCart(ThunkResolvedStatus.pending));
    try {
      const response = await apolloClient.query<
        GetGuestCartDetails,
        GetGuestCartDetailsVariables
      >({
        query: GET_GUEST_CART_DETAILS,
        variables: {
          cartId,
        },
        fetchPolicy: "no-cache",
      });
      const fetchGuestCartResponse = response?.data?.getGuestCartDetails;

      handleFetchGuestCartResponse(fetchGuestCartResponse, pathname, dispatch);
      dispatch(setFetchingCart(ThunkResolvedStatus.fulfilled));

      return fetchGuestCartResponse;
    } catch (fetchGuestCartError) {
      console.error("Failed to fetch guest cart", fetchGuestCartError);
      dispatch(setFetchingCart(ThunkResolvedStatus.rejected));
      throw fetchGuestCartError;
    }
  }
};
